/* global hbspt */

function createHubSpotForm() {
	// console.log( 'Attempting to create HubSpot form...' );
	try {
		hbspt.forms.create( {
			portalId: '20517815',
			formId: '48e77a50-7f75-44d1-8fce-7b970c4a34ef',
			region: 'na1',
			target: '#hubspot-form-container',
			onFormReady() {
				// console.log( 'HubSpot form loaded successfully' );
			},
			onFormSubmit() {
				// console.log( 'HubSpot form submitted' );
			},
		} );
	} catch ( error ) {
		console.error( 'Error creating HubSpot form:', error );
		document.getElementById( 'hubspot-form-container' ).innerHTML = `
			<p class="text-white text-center">Error loading newsletter form</p>
		`;
	}
}

function initializeNewsletterForm() {
	// Check if we're on localhost for fallback form
	const isLocalhost =
		window.location.hostname === 'localhost' ||
		window.location.hostname === '127.0.0.1' ||
		window.location.hostname.includes( '.local' );

	// console.log(
	// 	'Newsletter form init - Hostname:',
	// 	window.location.hostname,
	// 	'Is localhost:',
	// 	isLocalhost
	// );

	if ( isLocalhost ) {
		// console.log( 'Loading localhost fallback form' );
		// Fallback form for local development
		document.getElementById( 'hubspot-form-container' ).innerHTML = `
			<form class="hs-form bg-white p-6 rounded-lg shadow-lg max-w-lg mx-auto">
				<div class="mb-4">
					<label class="block text-gray-700 text-sm font-bold mb-2" for="email">
						Email Address
					</label>
					<input class="shadow appearance-none border w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" 
						   id="email" type="email" placeholder="Enter your email" required>
				</div>
				<div class="mb-4">
					<label class="block text-gray-700 text-sm font-bold mb-2" for="firstname">
						First Name
					</label>
					<input class="shadow appearance-none border w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
						   id="firstname" type="text" placeholder="Enter your first name">
				</div>
				<button class="bg-eng-gold-300 hover:bg-eng-gold-400 text-eng-black-100 font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full"
						type="submit">
					Subscribe (Local Demo)
				</button>
			</form>
		`;
	} else if ( window.hbspt && window.hbspt.forms ) {
		// Load the actual HubSpot form for production/staging
		// console.log( 'Loading HubSpot form for production/staging' );

		createHubSpotForm();
	} else {
		// Wait for HubSpot to load
		// console.log( 'Waiting for HubSpot to load...' );
		let attempts = 0;
		const maxAttempts = 30; // 15 seconds max

		const checkHubSpot = setInterval( function () {
			attempts++;
			if ( window.hbspt && window.hbspt.forms ) {
				// console.log( 'HubSpot loaded, creating form...' );
				clearInterval( checkHubSpot );
				createHubSpotForm();
			} else if ( attempts >= maxAttempts ) {
				console.error( 'HubSpot failed to load after 15 seconds' );
				clearInterval( checkHubSpot );
				document.getElementById(
					'hubspot-form-container'
				).innerHTML = `
					<p class="text-white text-center">Newsletter form temporarily unavailable</p>
				`;
			}
		}, 500 );
	}
}

// Initialize when DOM is ready
document.addEventListener( 'DOMContentLoaded', initializeNewsletterForm );
